<div class="cd-panel" [class.cd-panel--single]="blocks.length === 0">
  <section class="cd-card">
    <div class="cd-profile">
      <div class="cd-avatar">{{ initials }}</div>
      <div class="cd-profile__main">
        <span class="cd-profile__name">{{ row?.companyName || 'Sin nombre' }}</span>
        <span class="cd-profile__meta">
          <app-status-pill [label]="typeLabel" [variant]="row?.isClient && row?.isProvider ? 'brand' : row?.isClient ? 'success' : row?.isProvider ? 'info' : 'neutral'"></app-status-pill>
          <span *ngIf="row?.vatNumber">{{ row.vatNumber }}</span>
        </span>
      </div>
    </div>

    <div class="cd-contact">
      <div class="cd-contact__item">
        <mat-icon>email</mat-icon>
        <a *ngIf="row?.email; else noEmail" [href]="'mailto:' + row.email">{{ row.email }}</a>
        <ng-template #noEmail><span class="cd-muted">Sin email</span></ng-template>
      </div>
      <div class="cd-contact__item">
        <mat-icon>phone</mat-icon>
        <a *ngIf="row?.phone; else noPhone" [href]="'tel:' + row.phone">{{ row.phone }}</a>
        <ng-template #noPhone><span class="cd-muted">Sin teléfono</span></ng-template>
      </div>
      <div class="cd-contact__item">
        <mat-icon>place</mat-icon>
        <span *ngIf="address; else noAddress">{{ address }}</span>
        <ng-template #noAddress><span class="cd-muted">Sin dirección</span></ng-template>
      </div>
    </div>

    <div class="cd-lines" *ngIf="accountLines.length">
      <div class="cd-line" *ngFor="let line of accountLines">
        <span class="cd-line__label">{{ line.label }}</span>
        <span class="cd-line__value" [class.cd-muted]="!line.value">{{ line.value || 'Sin asignar' }}</span>
      </div>
    </div>
  </section>

  <div class="cd-side" *ngIf="blocks.length">
    <section class="cd-card" *ngFor="let block of blocks">
      <div class="cd-card__header">
        <span class="cd-card__title"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
        <span class="cd-card__hint" *ngIf="!block.loading && !block.error && block.count">{{ block.count }} {{ block.count === 1 ? 'documento' : 'documentos' }}</span>
      </div>

      <app-loading-state *ngIf="block.loading" [compact]="true" message="Cargando documentos…"></app-loading-state>

      <div class="cd-empty" *ngIf="!block.loading && block.error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar los documentos.</span>
        <button mat-stroked-button type="button" class="cf-btn" (click)="reload(block)">
          <mat-icon>autorenew</mat-icon> Reintentar
        </button>
      </div>

      <div class="cd-empty" *ngIf="!block.loading && !block.error && block.count === 0">
        <mat-icon>inbox</mat-icon>
        <span>{{ block.emptyText }}</span>
      </div>

      <ng-container *ngIf="!block.loading && !block.error && block.count > 0">
        <div class="cd-kpis">
          <div class="cd-kpi">
            <span class="cd-kpi__label">{{ block.totalLabel }}</span>
            <span class="cd-kpi__value">{{ block.total | number:'1.2-2' }} €</span>
          </div>
          <div class="cd-kpi">
            <span class="cd-kpi__label">{{ block.paidLabel }}</span>
            <span class="cd-kpi__value">{{ block.paid | number:'1.2-2' }} €</span>
          </div>
          <div class="cd-kpi" [class.cd-kpi--warn]="block.pending > 0.005">
            <span class="cd-kpi__label">Pendiente</span>
            <span class="cd-kpi__value">{{ block.pending | number:'1.2-2' }} €</span>
          </div>
        </div>

        <div class="cd-progress">
          <div class="cd-progress__bar">
            <div class="cd-progress__fill" [style.width.%]="block.percent"></div>
          </div>
          <span class="cd-progress__label">{{ block.percent }} % {{ block.paidLabel | lowercase }}</span>
        </div>

        <div class="cd-docs">
          <div class="cd-doc" *ngFor="let doc of block.items; trackBy: trackByUid">
            <span class="cd-doc__date">{{ doc.invoiceRelease | date:'dd/MM/yyyy' }}</span>
            <span class="cd-doc__number">{{ doc.invoiceNumber || 'Sin número' }}</span>
            <app-status-pill *ngIf="isPaid(doc)" [label]="block.paidLabel" variant="success"></app-status-pill>
            <app-status-pill *ngIf="isPartial(doc)" label="Parcial" variant="info"></app-status-pill>
            <app-status-pill *ngIf="!isPaid(doc) && !isPartial(doc)" label="Pendiente" variant="warning"></app-status-pill>
            <span class="cd-doc__amount">{{ doc.total | number:'1.2-2' }} €</span>
          </div>
        </div>

        <p class="cd-more" *ngIf="block.count > block.items.length">
          Últimos {{ block.items.length }} de {{ block.count }}. El resto en «Histórico» del menú del contacto.
        </p>
      </ng-container>
    </section>
  </div>
</div>
